<template>


    <div class="col-span-6">


        <div class="col-span-6 text-left">
            <div class="flex flex-row justify-between items-center">

                <div class="block">Paste this code snippet before the <code
                        class="text-green-500 text-sm">&lt;/body&gt;</code> tag in every page of your webapp -
                    <docs-link href="https://docs.birdie.so/birdie-docs/screen-recording/misc./web-sdk" />
                </div>

                <div v-if="has_installed_widget"
                    class="flex items-center gap-2 text-birdie-green font-bold flex-shrink-0">
                    Installed
                    <CheckCircleIcon class="w-5 h-5" />
                </div>
                <div v-else class="flex items-center gap-2 text-gray-500 flex-shrink-0">
                    Not installed
                    <XCircleIcon class="w-5 h-5" />
                </div>

            </div>
        </div>


        <div class="col-span-6 mt-5">

            <div class="flex flex-row justify-start w-full">

                <div class="relative rounded-xl overflow-hidden w-full code_background"
                    v-clipboard:copy="snippet_original" @click="copied">
                    <highlightjs class="overflow-auto px-5 py-4 whitespace-pre-wrap text-sm" language='javascript'
                        :code="snippet_original" />
                    <a href="#" v-clipboard:copy="snippet_original" @click.prevent.stop="copied"
                        class="absolute top-3 right-3 w-10 h-10 bg-gray-100 text-gray-800 flex flex-col justify-center items-center rounded-lg bg-opacity-50 transform duration-200 hover:bg-opacity-100 hover:scale-105"
                        v-tippy="{ content: 'copy in your clipboard' }">
                        <ClipboardIcon class="h-5 w-5" />
                    </a>
                </div>

            </div>


        </div>

        <div class="col-span-6 mt-5" v-if="!is_guest">

            <div class="flex flex-row justify-center px-4">
                <jet-button class="bg-blue-500" @click="openModal">
                    Send instructions to a developer
                </jet-button>
                <!-- <a id="emailLink" href="#" title="Send instructions to a teammate" data-toggle="modal" data-target="#emailTeammate">Need some help for installing? Email a teammate!</a> -->
            </div>

        </div>


        <modal-email-teammate v-if="!is_guest" type="inapp" ref="modalEmailTeammate"
            @confirmed="emailSent"></modal-email-teammate>

    </div>

</template>






<script>

import JetButton from '@/Jetstream/Button'
import ModalEmailTeammate from '@/Components/Modals/EmailTeammate'

import 'highlight.js/styles/github-dark.css'
import hljsVuePlugin from "@highlightjs/vue-plugin"

import { ClipboardIcon, XCircleIcon } from "@heroicons/vue/24/outline"
import { CheckCircleIcon } from "@heroicons/vue/24/solid"

export default {

    props: ["team_slug", "team_name", "snippet_original", "is_modal", "has_installed_widget"],

    components: {
        JetButton,
        ModalEmailTeammate, highlightjs: hljsVuePlugin.component, ClipboardIcon,
        XCircleIcon, CheckCircleIcon
    },

    data() {
        return {
            is_guest: this.$page.props.is_guest,
            faq1: false,
            onboard_install: false,
            app_name: this.$page.props.app_name
        }
    },

    created() {
        // if (!this.is_guest) {
        //     if (this.$page.props.user.current_team.metadata) {
        //         let json = JSON.parse(this.$page.props.user.current_team.metadata)
        //         if (json.onboard_install) {
        //             this.onboard_install = json.onboard_install == "yes"
        //         }
        //     }
        // }
    },
    computed: {
        // team_name() {
        //     return this.is_guest ? "" : this.$page.props.user.current_team.name
        // },
    },
    mounted() {

    },
    methods: {
        emailSent: function () {
            let options = {
                type: "default",
                timeout: 6000,
                position: "top-right",
                hideProgressBar: false,
            }
            this.$moshaToast("Message sent to your teammate!", options)
        },
        copied: function () {
            let options = {
                type: "default",
                timeout: 6000,
                position: "top-right",
                hideProgressBar: false,
            }
            this.$moshaToast("Code snippet copied in your clipboard!", options)
            this.set_onboarding_done()

        },
        openModal: function () {
            this.$refs.modalEmailTeammate.open()
        },
        set_onboarding_done() {
            if (this.onboard_install || this.is_guest) {
                return
            }
            let url = this.$page.props.api_url + '/v1/team/set_meta';
            var params = {
                meta: "onboard_install",
                value: "yes"
            };
            axios.post(url, params)
                .then(response => {
                    if (response.data) {
                        this.onboard_install = true
                        this.EventBus.emit('onboarding_step_validation', 'onboard_install');
                    }
                })
                .catch(e => {
                    console.error(e);
                });
        }
    }

}

</script>

<style>
.code_background {
    background-color: #172938;
}

.hljs {
    background: transparent !important;
}
</style>
